import { useCallback, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { KanagawaThemeProvider } from '@aid/theme';
import i18n from './i18n';
import { QueryProvider, KeycloakProvider, PermissionsProvider } from './providers';
import { router } from './routes/router';
import { keycloak } from './auth/keycloak';

export function App() {
  const [keycloakReady, setKeycloakReady] = useState(false);

  const handleKeycloakReady = useCallback(() => {
    setKeycloakReady(true);
  }, []);

  useEffect(() => {
    const handler = () => {
      // Session invalid (401 that survived token refresh): close the Keycloak
      // session so the app does not loop between login redirects with a stale
      // SSO cookie.
      keycloak.logout({ redirectUri: window.location.origin + '/login' });
    };
    window.addEventListener('aid:session-expired', handler);
    return () => window.removeEventListener('aid:session-expired', handler);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <KanagawaThemeProvider>
        <ConfigProvider locale={esES}>
          <QueryProvider>
            <KeycloakProvider onReady={handleKeycloakReady}>
              {keycloakReady && (
                <PermissionsProvider>
                  <RouterProvider router={router} />
                </PermissionsProvider>
              )}
            </KeycloakProvider>
          </QueryProvider>
        </ConfigProvider>
      </KanagawaThemeProvider>
    </I18nextProvider>
  );
}
